import React, { Component } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import queryString from "query-string"
import { bindActionCreators } from "redux"
import { actionCreators, selectors } from "../store/actions/search"
import { WINDOW } from "../constants/environment"
import { getComponentDisplayName } from "../utils"

export default () => (Wrapped) => {
  class withSearch extends Component {
    constructor(props) {
      super(props)
      // Populate search store from initialSearchApiData
      props.loadInitialData()
      // Parse query from initialQueryString from backend for server-side render
      if (!WINDOW && props.initialQueryString) {
        const { q } = queryString.parse(props.initialQueryString)
        this.serverSideQuery = q
      }
    }

    render() {
      const {
        initialSearchApiData: { hits, page },
        initialQueryString,
        siteSearch: { query, ...siteSearch },
        ...props
      } = this.props
      // Get searchResults directly from initialSearchProps on server side
      return (
        <Wrapped
          {...props}
          query={query || ""}
          searchResultsData={WINDOW ? siteSearch : { results: hits }} />
      )
    }
  }

  withSearch.propTypes = {
    initialSearchApiData: PropTypes.object,
    initialQueryString: PropTypes.string,
    injestSearchData: PropTypes.func
  }

  const mapStateToProps = state => ({
    siteSearch: {
      ...selectors.getCurrentPageData(state),
      ...selectors.getSiteStatus(state)
    }
  })

  const mapDispatchToProps = dispatch => bindActionCreators(actionCreators, dispatch)

  withSearch.displayName = `withSearch(${getComponentDisplayName(Wrapped)})`

  return connect(mapStateToProps, mapDispatchToProps)(withSearch)
}



// WEBPACK FOOTER //
// ./src/higher-order-components/with-search.jsx